
import Idb from '@/Plugins/idb'
import Hashes from './Hashes'

export default {
  mixins: [
    Hashes,
  ],

  computed: {
    db () {
      return this.$store.state.db
    },
  },

  methods: {
    async openDB () {
      this.$store.commit('db', await Idb.open())
    },
    truncateDB () {
      return Idb.truncate(this.db)
    },
    async getKeyval (key) {
      return await this.db.get('keyval', key)
    },
    async setKeyval (key, val) {
      return await this.db.put('keyval', val, key)
    },
    // async delKeyval (key) {
    //   return await this.db.delete('keyval', key)
    // },
    async dbPutArray (model, records) {
      if (model == 'TenantUser') {
        this.hashSensibleData(records)
      }
      for (const record of records) {
        await this.db.put(model, record)
      }
    },
    async dbDelArray (model, records) {
      for (const record of records) {
        await this.db.delete(model, record.id)
      }
    },
    hashSensibleData (records) {
      records.forEach(o => {
        if (o.pin !== null) {
          o.pin = this.hash(o.pin)
        }
      })
    },
  },
}
